import { AutomaticPaymentRemindersType } from '../../../../../enums/automaticPaymentRemindersType'

export const automaticPaymentRemindersModalTitleTKeyByType: Record<AutomaticPaymentRemindersType, string> = {
  [AutomaticPaymentRemindersType.AfterDueDate]:
    'settings.organization.external_invoice.automatic_payment_reminders.modal.after_due_date.title',
  [AutomaticPaymentRemindersType.BeforeDueDate]:
    'settings.organization.external_invoice.automatic_payment_reminders.modal.before_due_date.title',
  [AutomaticPaymentRemindersType.OnDueDate]:
    'settings.organization.external_invoice.automatic_payment_reminders.modal.on_due_date.title',
}
